import React from 'react';
import './ForYou2.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';

export default function ForYou2({ content }) {

    return (
        <div className='workshop-for_you2'>
            <ul className='workshop-for_you2__list'>
                {
                    content.Parts_section.map((part) => (
                        <li key={part.id} className='workshop-for_you2__list-item' style={{backgroundColor: part.CouleurArrièrePlan, color: part.CouleurTexte}}>
                            <h3 className='workshop-for_you2__title'>{part.Titre}</h3>
                            <div className="workshop-for_you2__content" dangerouslySetInnerHTML={safeHtml(part.Texte)} />
                            <p className='workshop-for_you2__normal bold'>{part.Note}</p>
                        </li>
                    ))
                }
            </ul>
            <StrapiImageWithSkeleton
                picture={content.ImageRondeCentrale}
                loading="lazy"
                size='thumbnail'
                className="workshop-for_you2__picture"
            />
        </div>
    )
}
